'use strict';

// Organization workspace — the richest relationship graph of the new set. Config-only (no bespoke renderers):
// Overview field groups + M:N association tabs + FK child-list tabs, all resolved by the pict-section-workspace base.

module.exports = {
	Identifier: 'OrganizationWorkspace',
	Ordinal: 240,
	Entity: { Name: 'Organization', IDField: 'IDOrganization', Collection: 'Organizations', GUIDField: 'GUIDOrganization' },
	Header:
	{
		Eyebrow: 'Organization',
		Title: (pRec) => pRec.Name || `Organization ${pRec.IDOrganization}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ],
		ListRoute: '#/PSRS/Organization/List',
	},
	Tabs:
	[
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'contacts', Label: 'Contacts', Icon: 'fas fa-address-card', Content: { kind: 'assoc', ref: 'ContactOrganization' } },
		{ Key: 'projects', Label: 'Projects', Icon: 'fas fa-folder-open', Content: { kind: 'assoc', ref: 'OrganizationProject' } },
		{ Key: 'equipment', Label: 'Equipment', Icon: 'fas fa-screwdriver-wrench', Content: { kind: 'assoc', ref: 'EquipmentOrganization' } },
		{ Key: 'materials', Label: 'Materials', Icon: 'fas fa-cube', Content: { kind: 'assoc', ref: 'MaterialOrganization' } },
		{ Key: 'products', Label: 'Products', Icon: 'fas fa-box', Content: { kind: 'childlist', ref: 'Product', parentField: 'IDOrganization',
			columns: [ { Key: 'Name', Label: 'Name' }, { Key: 'ManufacturerCode', Label: 'Mfr Code' }, { Key: 'CatalogCode', Label: 'Catalog Code' } ], empty: 'No products from this organization.' } },
		{ Key: 'plants', Label: 'Production Plants', Icon: 'fas fa-industry', Content: { kind: 'childlist', ref: 'ProductionPlant', parentField: 'IDOrganization',
			columns: [ { Key: 'Name', Label: 'Name' } ], empty: 'No production plants for this organization.' } },
		{ Key: 'mixdesigns', Label: 'Mix Designs', Icon: 'fas fa-flask-vial', Content: { kind: 'childlist', ref: 'MixDesign', parentField: 'IDOrganization',
			columns: [ { Key: 'Name', Label: 'Name' }, { Key: 'MaterialCode', Label: 'Material Code' } ], empty: 'No mix designs.' } },
	],
	FieldGroups:
	[
		{ Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'VendorCode', Label: 'Vendor Code', Mono: true }, { Key: 'Type', Label: 'Type' } ] },
		{ Name: 'Contact', Fields: [ { Key: 'Address', Label: 'Address', Wide: true }, { Key: 'City', Label: 'City' }, { Key: 'State', Label: 'State' }, { Key: 'Zip', Label: 'Zip' }, { Key: 'Phone', Label: 'Phone' }, { Key: 'Email', Label: 'Email' } ] },
		{ Name: 'Status', Fields: [ { Key: 'Approved', Label: 'Approved', Format: 'bool' }, { Key: 'DisadvantagedBusiness', Label: 'Disadvantaged Business', Format: 'bool' }, { Key: 'FederalTaxCode', Label: 'Federal Tax Code', Mono: true }, { Key: 'ExternalOrganizationID', Label: 'External ID', Mono: true } ] },
	],
};
